import {
  Directive,
  ElementRef,
  inject,
  input,
  effect,
  Renderer2
} from '@angular/core';
import { SessionService } from '@/core/session.service';

/**
 * Directiva que oculta el elemento si el usuario no tiene concedido el recurso indicado.
 * Uso: <button [isGranted]="'RESOURCE_ID'">...</button>
 */
@Directive({
  selector: '[isGranted]',
  standalone: true
})
export class IsGrantedDirective {
  private readonly sessionService = inject(SessionService);
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);

  /** Identificador del recurso a comprobar con SessionService.isGranted */
  readonly isGranted = input.required<string>({ alias: 'isGranted' });

  constructor() {
    effect(() => {
      const resource = this.isGranted();
      const granted = this.sessionService.isGranted(resource);
      if (granted) {
        this.renderer.removeStyle(this.el.nativeElement, 'display');
      } else {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      }
    });
  }
}
